module.exports = __webpack_public_path__ + "static/media/HB_lasagna_forweb_edited.f845b574.jpg";